import { InjectionToken } from '@angular/core';
import { AppSettings } from '@core/models/app-settings.model';

export const APP_CONFIG = new InjectionToken<AppSettings>('Application settings');
